import { TicketTypeType } from '@vista-digital/ocapi-types/v1';
import { addMonetaryValues } from '../../../../utils/monetary-value-utils';
import { getTicketTypeById } from '../../../sales-data/selectors/tickets/get-ticket-type-by-id';
import { isMemberTicketType } from '../../../sales-data/utils/tickets/ticket-type-utils';
export const isOrderPackageTicketLine = (ticketLine) => {
    return ticketLine.type === TicketTypeType.Package;
};
export const getOrderTicketLineTicketCount = (ticketLine) => {
    return isOrderPackageTicketLine(ticketLine) ? getOrderPackageTicketLineTicketCount(ticketLine) : 1;
};
export const getOrderPackageTicketLineTicketCount = (ticketLine) => {
    return ticketLine.tickets.length;
};
export const getTotalPriceOfOrderTicketLines = (tickets) => addMonetaryValues(...tickets.map(ticket => ticket.price));
export const getTicketCountOfTicketLines = (tickets) => {
    return tickets.reduce((acc, ticket) => acc + getOrderTicketLineTicketCount(ticket), 0);
};
export const containsAnyMemberTicketLines = (tickets) => {
    return tickets.some(ticket => {
        if (ticket.rewardId !== undefined && ticket.rewardId !== null)
            return true;
        const ticketType = getTicketTypeById(ticket.ticketTypeId);
        return isMemberTicketType(ticketType);
    });
};
